import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { handleUploadCapturedImg } from '../handler/UploadImageHandler';

const ImageCapture = forwardRef(function ImageCapture({
    corporationDetail,
    projectInuseDetail,
    chatThreadId,
    currentUploadImgs = [],
    currentUploadFiles = [],
    setUploadImgs,
    showButton = true
}, ref) {
    const inputRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();

    useImperativeHandle(ref, () => ({
        triggerClick: () => {
            inputRef.current?.click();
        }
    }));

    return (
        <div>
            {showButton && (
                <button
                    className="btn-reset-default ai-chat-input-btn"
                    onClick={() => inputRef.current?.click()}
                >
                    <CameraAltIcon />
                </button>
            )}
            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                onChange={e => {
                    const file = e.target.files[0];
                    handleUploadCapturedImg({
                        file,
                        currentUploadImgs: currentUploadImgs,
                        currentUploadFiles: currentUploadFiles,
                        setUploadImgs,
                        enqueueSnackbar,
                        corporationDetail,
                        projectInuseDetail,
                        chatThreadId
                    });
                    e.target.value = ''; // reset after capture
                }}
            />
        </div>
    );
});

ImageCapture.propTypes = {
    corporationDetail: PropTypes.object,
    projectInuseDetail: PropTypes.object,
    chatThreadId: PropTypes.string,
    currentUploadImgs: PropTypes.array,
    currentUploadFiles: PropTypes.array,
    setUploadImgs: PropTypes.func,
    showButton: PropTypes.bool
};

export default ImageCapture;
